import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import { AdminCmsListItem } from '../fragments';

export default gql`
query adminCmsList($filters: AdminCmsContentFilters, $sortBy: AdminCmsContentOrder, $count: Int!, $page: Int) {
    adminCmsContents(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...AdminCmsListItem
        }
    }
}
${PaginatorInfoFragment}
${AdminCmsListItem}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminCmsContents.ts